import { memo, useMemo } from 'react';
import { COLOR_TYPES } from './_constants';

type TProps = {
  color?: keyof typeof COLOR_TYPES;
  size?: number;
};

export const AttentionIcon = memo(({ color = 'orange', size = 24 }: TProps) => {
  const colorType = useMemo(() => {
    return COLOR_TYPES[color];
  }, [color]);

  return (
    <svg
      fill={colorType}
      height={size}
      viewBox="0 0 18 18"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="9" cy="9" r="9" />
      <path
        d="M9.98984 3.5V7.79C9.98984 8.245 9.96484 8.695 9.91484 9.14C9.86984 9.585 9.80484 10.0475 9.71984 10.5275H8.32484C8.23984 10.0475 8.17234 9.585 8.12234 9.14C8.07734 8.695 8.05484 8.245 8.05484 7.79V3.5H9.98984ZM7.77734 13.295C7.77734 13.13 7.80734 12.975 7.86734 12.83C7.93234 12.68 8.01984 12.5525 8.12984 12.4475C8.23984 12.3375 8.36734 12.2525 8.51234 12.1925C8.66234 12.1275 8.82484 12.095 8.99984 12.095C9.16984 12.095 9.32734 12.1275 9.47234 12.1925C9.62234 12.2525 9.75234 12.3375 9.86234 12.4475C9.97234 12.5525 10.0598 12.68 10.1248 12.83C10.1898 12.975 10.2223 13.13 10.2223 13.295C10.2223 13.465 10.1898 13.6225 10.1248 13.7675C10.0598 13.9125 9.97234 14.04 9.86234 14.15C9.75234 14.255 9.62234 14.3375 9.47234 14.3975C9.32734 14.4575 9.16984 14.4875 8.99984 14.4875C8.82484 14.4875 8.66234 14.4575 8.51234 14.3975C8.36734 14.3375 8.23984 14.255 8.12984 14.15C8.01984 14.04 7.93234 13.9125 7.86734 13.7675C7.80734 13.6225 7.77734 13.465 7.77734 13.295Z"
        fill="white"
      />
    </svg>
  );
});
